/**
 * @generated SignedSource<<0c7df427cf122c70944c16ca854ad0a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useUsersRelayByIdQuery$variables = {
  id: string;
};
export type useUsersRelayByIdQuery$data = {
  readonly getUser: {
    readonly authStatus: number | null | undefined;
    readonly createdOn: any | null | undefined;
    readonly delinquent: boolean | null | undefined;
    readonly email: string | null | undefined;
    readonly firstName: string;
    readonly fullName: string | null | undefined;
    readonly id: string;
    readonly language: string | null | undefined;
    readonly lastName: string;
    readonly organizationIds: ReadonlyArray<string> | null | undefined;
    readonly phone: string;
    readonly region: string;
    readonly systemIds: ReadonlyArray<string> | null | undefined;
    readonly userMemberships: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly userSystems: ReadonlyArray<{
      readonly acceptedTosOn: any | null | undefined;
      readonly blacklisted: boolean | null | undefined;
      readonly hidden: boolean | null | undefined;
      readonly id: string;
      readonly joined: any | null | undefined;
      readonly rejected: boolean | null | undefined;
      readonly removed: boolean | null | undefined;
      readonly systemId: string | null | undefined;
    }>;
  } | null | undefined;
};
export type useUsersRelayByIdQuery = {
  response: useUsersRelayByIdQuery$data;
  variables: useUsersRelayByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "getUser",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phone",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fullName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "delinquent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "authStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "language",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "region",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserSystem",
        "kind": "LinkedField",
        "name": "userSystems",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "blacklisted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hidden",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "joined",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rejected",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "removed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "acceptedTosOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "systemId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "limit",
            "value": 1
          }
        ],
        "concreteType": "UserMembership",
        "kind": "LinkedField",
        "name": "userMemberships",
        "plural": true,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": "userMemberships(limit:1)"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUsersRelayByIdQuery",
    "selections": (v2/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUsersRelayByIdQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "544038cbd7f6e9533c0656f9a48beadd",
    "id": null,
    "metadata": {},
    "name": "useUsersRelayByIdQuery",
    "operationKind": "query",
    "text": "query useUsersRelayByIdQuery(\n  $id: ID!\n) {\n  getUser(id: $id) {\n    id\n    phone\n    email\n    firstName\n    lastName\n    fullName\n    createdOn\n    delinquent\n    authStatus\n    language\n    region\n    organizationIds\n    systemIds\n    userSystems {\n      id\n      blacklisted\n      hidden\n      joined\n      rejected\n      removed\n      acceptedTosOn\n      systemId\n    }\n    userMemberships(limit: 1) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d2f7b634d720cdc9d514453484dccfe1";

export default node;
